import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Legal({ slug }) {
  const { t } = useLanguage();
  const data = t.legal[slug];
  const meta = t.meta[slug];
  usePageMeta(meta.title, meta.desc);

  return (
    <main>
      <PageHero eyebrow={t.nav.home} title={data.title} body={data.intro} />
      <section className="pb-24 pt-4 md:pb-32">
        <div className="mx-auto max-w-4xl px-6 lg:px-10">
          {data.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05}>
              <div data-testid={`legal-${slug}-section-${i + 1}`} className="border-t hairline py-10 first:border-t-0 first:pt-2">
                <h2 className="font-serif text-2xl text-gold-light sm:text-3xl">{s.h}</h2>
                {s.p.map((para, j) => (
                  <p key={j} className="mt-4 text-[15px] leading-relaxed text-cream/70">
                    {para}
                  </p>
                ))}
              </div>
            </Reveal>
          ))}
          <span className="block border-t hairline" />
        </div>
      </section>
    </main>
  );
}
